
import { defineComponent } from 'vue';
import EnlargeIcon from '@/components/icons/EnlargeIcon.vue';
import PreviewImageModal from '@/components/preview-image/PreviewImageModal.vue';
import { baseFileUrl } from '@/utils/constants';

interface CatalogueItemProps {
  previewImg: string[];
  [key: string]: any;
}

export default defineComponent({
  name: 'CatalogueItem',
  components: {
    EnlargeIcon,
    PreviewImageModal
  },
  data(): CatalogueItemProps {
    return {
      baseFileUrl,
      showPreviewModal: false,
      previewImg: []
    };
  },
  props: {
    item: {
      type: Object,
      required: true,
      default: () => {
        return {};
      }
    },
    model: {
      type: String,
      default: ''
    },
    vehicleId: {
      type: Number,
      default: 0
    }
  },
  computed: {
    getImg() {
      let res = '';
      const partsImgs = this.item.partsImgs || [];

      if (partsImgs.length > 0 && partsImgs[0].fileUrl) {
        res = baseFileUrl + partsImgs[0].fileUrl;
      }

      return res;
    }
  },
  created() {
    this.$bus.$on('calculate-img', this.calculateImg);
  },
  mounted() {
    this.calculateImg();
  },
  methods: {
    calculateImg() {
      const imgs: any[] = Array.from(
        document.querySelectorAll('.c-img-container')
      );

      imgs.forEach(e => {
        if (e.parentElement) {
          e.style.height = `${(e.parentElement?.offsetWidth * 5) / 8}px`;
        }
      });
    },
    onImgClick() {
      this.previewImg.push(this.getImg);
      this.showPreviewModal = true;
    },
    handleAfterClose() {
      this.showPreviewModal = false;

      this.previewImg = [];
    },
    gotoDiagram() {
      this.$router.push(
        `/diagram/${this.item.id}/${this.vehicleId}?model=${this.model ||
          ''}&partName=${this.item.partName}`
      );
    }
  }
});
